import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpBackend } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { KeyvaultConfig } from 'src/app/models/key-vault-config-values.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private httpClient: HttpClient;

  static settings: KeyvaultConfig; 

  constructor(private http: HttpClient, httpBackend: HttpBackend) { 
    // Use local HttpClient to avoid interceptor loop
    this.httpClient = new HttpClient(httpBackend);
  }

  endpoint = environment.apiUrl;
  
  load() {
    return new Promise((resolve, reject) => {
      this.httpClient.get<any>(this.endpoint + 'tenant/keyVault')
        .pipe(map(res => {
          return res;
        }))
        .toPromise().then((res: KeyvaultConfig) => {
          ConfigService.settings = res;  
          ConfigService.settings.graphUrl = 'https://graph.microsoft.com/v1.0/me';   
          resolve(true);
          
        }).catch((response: any) => {
          reject(`Error: ${JSON.stringify(response)}`);
        });
    });
  }
}
